module.exports = __webpack_public_path__ + "img/card_left.f0c2d610.png";